import { observer } from 'mobx-react-lite';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components/isolated/Button';
import { IconButton } from '~/components/isolated/IconButton';
import Modal from '~/components/Modal/Modal';
import { useSlotsChangedEvent } from '~/components/ModalSlotsChangedEvent/useSlotsChangedEvent';
import { useGlobal } from '~/hooks/useGlobal';

import { DeliveryDifferenceItem } from './components/DeliveryDifferenceItem';
import styles from './ModalSlotsChangedEventCD.module.scss';

const ModalSlotsChangedEventCD = () => {
  const { slotsChangedEventStore, handleCloseModal, getKey } =
    useSlotsChangedEvent();
  const { t } = useTranslation();
  const { isMobile } = useGlobal();

  const content = (
    <Modal
      isShow={slotsChangedEventStore.isOpen}
      className={styles.root}
      onBackdropDismiss={handleCloseModal}
    >
      <section className={styles.head}>
        <h2 className={styles.title}>
          {t('deliverySlotsChangedEvent:titleShort')}
        </h2>
        {!isMobile && (
          <IconButton
            variant="outline"
            size="S"
            icon="close"
            onClick={handleCloseModal}
          />
        )}
      </section>
      <main className={styles.body}>
        {slotsChangedEventStore.difference && (
          <div className={styles.differenceList}>
            {slotsChangedEventStore.difference.map((item) => {
              const key = getKey(item.slotDeliveryDetails);
              return <DeliveryDifferenceItem key={key} differenceItem={item} />;
            })}
          </div>
        )}
      </main>
      <section className={styles.footer}>
        <Button size="XL" className={styles.okBtn} onClick={handleCloseModal}>
          {t(isMobile ? 'gotItButton' : 'okButton')}
        </Button>
      </section>
    </Modal>
  );

  if (typeof document === 'undefined' || !slotsChangedEventStore.isOpen) {
    return null;
  }

  return createPortal(content, document.body);
};

export default observer(ModalSlotsChangedEventCD);
